const ServicioValidacion = function () {

  // Expresiones Regulares
  const RE_CORREO = /^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[A-Z0-9-]+\.)+[A-Z]{2,6}$/i,
    RE_RFC_FISICA = /^(([A-ZÑ]|[a-zñ]|\s){1})(([A-ZÑ]|[a-zñ]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))$/,
    RE_RFC_MORAL = /^(([A-ZÑ]|[a-zñ]){3})(([0-9]){6})((([A-Z]|[a-z]|[0-9]){3}))$/,
    RE_UUID = /^[a-f0-9A-F]{8}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{12}$/,
    RE_INT = /^\d+$/;

  // Funciones
  const EsCorreoValido = correo => RE_CORREO.test(correo),
    EsRfcFisicaValido = rfc => RE_RFC_FISICA.test(rfc),
    EsRfcMoralValido = rfc => RE_RFC_MORAL.test(rfc),
    EsRfcValido = rfc => EsRfcFisicaValido(rfc) || EsRfcMoralValido(rfc),
    EsUUIDValido = uuid => RE_UUID.test(uuid);

  // Exports
  this.RE_CORREO = RE_CORREO;
  this.RE_RFC_FISICA = RE_RFC_FISICA;
  this.RE_RFC_MORAL = RE_RFC_MORAL;
  this.RE_UUID = RE_UUID;
  this.RE_INT = RE_INT;

  this.EsCorreoValido = EsCorreoValido;
  this.EsRfcValido = EsRfcValido;
  this.EsRfcFisicaValido = EsRfcFisicaValido;
  this.EsRfcMoralValido = EsRfcMoralValido;
  this.EsUUIDValido = EsUUIDValido;

};

export default ServicioValidacion;
